export default __webpack_public_path__ + "static/europe-uk-aacd18351ff8baa9e4f67c3317708b61.svg";